export const comingSoonStyles = {
  height: '600px',
  marginBottom: '20px',
  width: '800px'
}
